<div
  [ngClass]="{
    'pb-[16px]':
      !content.todayTrip.departureCityCode &&
      content.errorMessages.errorMessageDescription
  }"
  class="flyout-today__container flex w-full pt-[16px] px-[24px] tablet:h-[56vh] laptop:h-auto pb-0 flex-col justify-center items-center gap-[24px]"
  tabindex="1"
>
  <div class="flyout-today__content tablet:w-[656px] laptop:w-[295px]">
    <div
      class="flyout-today__flight-info w-[263px] laptop:w-[295px] h-[104px] mb-[24px]"
      *ngIf="content.todayTrip.departureCityCode"
    >
      <div
        class="flyout-today__flight-number flex flex-wrap items-start self-stretch text-label-xs-semibold text-subtle"
      >
        <span
          class="flyout-today__carrier-code text-label-xs-semibold text-subtle"
        >
          {{ content.todayTrip.mktCarrierCode }}
          {{ content.todayTrip.mktFlightNumber }}
        </span>
        <span
          *ngIf="content.todayTrip.optCarrierCode"
          class="flyout-today__carrier-code text-label-xs-semibold text-subtle"
        >
          {{ content.labels.operatedByLabel }}
          {{ content.todayTrip.optCarrierCode }}
        </span>
      </div>
      <div>
        <a
          (click)="mytripsTodayClick(content.arrowFlightDetailsOpenNewTab)"
          [attr.target]="
            content.arrowFlightDetailsOpenNewTab ? '_blank' : '_self'
          "
          [ngClass]="
            content.disableViewLink ? 'flyout-today__link--disabled' : ''
          "
          class="flyout-today__link no-underline contents"
          href="javascript:void(0)"
          ng-disabled="disableViewLink"
          role="link"
        >
          <form
            #flyoutTodayMytripsForm
            *ngIf="content.todayTrip.viewTripDetails"
            [action]="content.tripLinkFormAction"
            id="flyout-todayTrip-link"
            class="flyout-today__form"
            method="POST"
            novalidate
          >
            <input
              name="confirmationNo"
              type="hidden"
              value="{{ content.todayTrip.recordLocator }}"
            />
            <input
              name="firstName"
              type="hidden"
              value="{{ content.todayTrip.firstName }}"
            />
            <input
              name="lastName"
              type="hidden"
              value="{{ content.todayTrip.lastName }}"
            />
            <input name="flagFromMyProfile" type="hidden" value="Y" />
            <input name="interstitial" type="hidden" value="true" />
          </form>
          <div class="flyout-today__route flex flex-wrap">
            <div
              class="flyout-today__city flyout-today__city--departure flex flex-col items-start mr-[32px]"
            >
              <div
                class="flyout-today__city-code text-[#001E3C] text-heading-md"
              >
                {{ content.todayTrip.departureCityCode }}
              </div>
              <div
                class="flyout-today__time-info flex flex-col text-caption-medium text-subtle"
              >
                <span>
                  {{ content.labels.departLabel }}
                  <span *ngIf="content.todayTrip.actualFlightDepartureTime">
                    {{ content.todayTrip.actualFlightDepartureTime }}
                  </span>
                  <span *ngIf="!content.todayTrip.actualFlightDepartureTime">
                    {{ content.todayTrip.scheduleFlightDepartureTime }}
                  </span>
                </span>
                <span *ngIf="content.todayTrip.actualFlightDepartureTime">
                  ({{ content.labels.wasLabel }}
                  {{ content.todayTrip.scheduleFlightDepartureTime }})
                </span>
              </div>
            </div>
            <div
              class="flyout-today__arrow flex flex-col items-start pt-5 mr-[32px]"
            >
              <svg
                width="12"
                height="70"
                viewBox="0 0 12 70"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M9 26L3 31.25L3 20.75L9 26Z"
                  fill="#001E3C"
                />
              </svg>
            </div>

            <div
              class="flyout-today__city flyout-today__city--arrival flex flex-col items-start"
            >
              <div class="flyout-today__city-code text-heading-md">
                {{ content.todayTrip.arrivalCityCode }}
              </div>
              <div
                class="flyout-today__time-info flex flex-col text-caption-medium text-subtle"
              >
                <span>
                  {{ content.labels.arriveLabel }}
                  <span *ngIf="content.todayTrip.actualFlightArrivalTime">
                    {{ content.todayTrip.actualFlightArrivalTime }}
                  </span>
                  <span *ngIf="!content.todayTrip.actualFlightArrivalTime">
                    {{ content.todayTrip.scheduleFlightArrivalTime }}
                  </span>
                </span>
                <span *ngIf="content.todayTrip.actualFlightArrivalTime">
                  ({{ content.labels.wasLabel }}
                  {{ content.todayTrip.scheduleFlightArrivalTime }})
                </span>
              </div>
            </div>
          </div>
          <span *ngIf="!content.disableViewLink" class="sr-only">
            {{ content.todayTrip.departureCityCode }} -
            {{ content.todayTrip.arrivalCityCode }} Trip details
          </span>
        </a>
      </div>
    </div>
    <div
      *ngIf="content.todayTrip.departureCityCode && !showIropModel"
      class="divider border-surface-01 mb-[24px] border-[1px]"
    ></div>
    <div
      class="flyout-today__status-section flex flex-col w-full gap-[24px]"
      *ngIf="content.todayTrip.departureCityCode && !showIropModel"
    >
      <div class="flex flex-wrap gap-[24px] items-baseliner">
        <div class="flex flex-col items-start gap-[4px] flex-1">
          <div
            class="flyout-today__status-label text-label-xs-semibold text-subtle"
          >
            {{ content.labels.statusLabel }}
          </div>
          <div
            class="flex flex-wrap w-max gap-[8px] text-label-lg-medium text-heading items-center"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              *ngIf="
                showGreenAeroStatus(content.todayTrip.flightStatus.statusColor)
              "
              class="flyout-today__status-icon flyout-today__status-icon--green mt-[5px]"
              [ngClass]="{
                'd-none': showNoShow(content.todayTrip.flightStatus)
              }"
              alt="flight status"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z"
                fill="#167B3D"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M9.15565 12.5703L10.0928 11.9729L10.0867 7.38269L12.6769 5.77721C12.9244 5.62406 12.9995 5.30256 12.8423 5.06118C12.6851 4.81778 12.3575 4.74577 12.109 4.89891L9.54814 6.50439L5.37573 4.57031L4.40818 5.16768L7.2094 7.92731L5.34226 9.08147L4.3879 8.46889L3.42847 9.0622L4.72157 10.0794L5.10494 11.6606L6.06538 11.0673L5.90818 9.95976L7.77634 8.80662L9.15565 12.5703Z"
                fill="white"
              />
            </svg>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              *ngIf="
                showOrangeAeroStatus(content.todayTrip.flightStatus.statusColor)
              "
              class="flyout-today__status-icon flyout-today__status-icon--orange mt-[5px]"
              [ngClass]="{
                'd-none': showNoShow(content.todayTrip.flightStatus)
              }"
              alt="flight status"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z"
                fill="#AB5300"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M9.15565 12.5703L10.0928 11.9729L10.0867 7.38269L12.6769 5.77721C12.9244 5.62406 12.9995 5.30256 12.8423 5.06118C12.6851 4.81778 12.3575 4.74577 12.109 4.89891L9.54814 6.50439L5.37573 4.57031L4.40818 5.16768L7.2094 7.92731L5.34226 9.08147L4.3879 8.46889L3.42847 9.0622L4.72157 10.0794L5.10494 11.6606L6.06538 11.0673L5.90818 9.95976L7.77634 8.80662L9.15565 12.5703Z"
                fill="white"
              />
            </svg>
            <img
              *ngIf="
                showRedAeroStatus(content.todayTrip.flightStatus.statusColor)
              "
              class="flyout-today__status-icon warn flyout-today__status-icon--red mt-[5px]"
              [ngClass]="{
                'd-none':
                  content.todayTrip.flightStatus &&
                  content.todayTrip.flightStatus.status &&
                  content.todayTrip.flightStatus.status.indexOf('not') === -1
                    ? false
                    : true
              }"
              alt="flight status"
              src="/content/dam/delta-applications/ui-kit/assets/svg/trip-status/aero-red.svg"
            />
            <div
              class="flyout-today__status-text text-label-md-medium mt-[0.15rem] ml-0"
              [ngClass]="[
                !(
                  content.todayTrip.flightStatus &&
                  content.todayTrip.flightStatus.status &&
                  content.todayTrip.flightStatus.status.indexOf('not') === -1
                )
                  ? 'text-label-md-medium'
                  : '',
                getStatusTextColorChange(
                  content.todayTrip.flightStatus.statusColor
                )
              ]"
            >
              {{
                content.todayTrip.flightStatus &&
                content.todayTrip.flightStatus.status &&
                content.todayTrip.flightStatus.status.indexOf('not') === -1
                  ? content.todayTrip.flightStatus.status
                  : '--'
              }}
            </div>
          </div>
        </div>
        <div class="flex flex-col items-start gap-[4px] flex-1">
          <div class="text-label-xs-semibold text-subtle">
            {{ content.labels.gateLabel }}
          </div>
          <div class="text-label-lg-medium text-heading">
            <span>
              {{
                content.todayTrip.flightStatus &&
                content.todayTrip.flightStatus.gate
                  ? content.todayTrip.flightStatus.gate
                  : '--'
              }}
            </span>
            <span>
              {{ content.todayTrip.flightStatus.terminal }}
            </span>
          </div>
        </div>
      </div>
      <div class="flex flex-wrap gap-[24px] items-baseline">
        <div class="flex flex-col items-start gap-[4px] flex-1">
          <div class="text-label-xs-semibold text-subtle">
            {{ content.todayTrip.membershipLevel }}
          </div>
          <div class="text-label-lg-medium text-heading">
            {{ content.todayTrip.firstName }} {{ content.todayTrip.middleName }}
            {{ content.todayTrip.lastName }}
          </div>
        </div>
        <div class="flex flex-col items-start gap-[4px] flex-1">
          <div class="text-label-xs-semibold text-subtle">
            {{ content.labels.seatLabel }}
          </div>
          <div class="text-label-lg-medium text-heading">
            {{
              content.todayTrip.seatNumber ? content.todayTrip.seatNumber : '--'
            }}
          </div>
        </div>
      </div>
      <div class="flex flex-col w-full gap-[8px] pb-[24px]">
        <button
          *ngIf="content.todayTrip.checkedIn"
          class="button button-secondary button-md w-full px-[32px] h-[52px] rounded-[4px] border-0 p-0 m-0 flex items-center justify-center"
          role="button"
          (click)="
            navigateToCheckin(
              this.content.viewBoardingPassOpenNewTab,
              content.checkInPath
            )
          "
          tabindex="0"
        >
          {{ content.labels.viewBoardingPassLabel }}
          <span
            *ngIf="
              content.viewBoardingPassOpenNewTab;
              else viewBoardingSameWindow
            "
            class="sr-only"
          >
            Open in new window
          </span>
          <ng-template #viewBoardingSameWindow>
            <span class="sr-only">Open in same window</span>
          </ng-template>
        </button>
        <button
          *ngIf="
            content.todayTrip.checkInEligible && !content.todayTrip.checkedIn
          "
          class="button button-primary button-md w-full px-[32px] h-[52px] rounded-[4px] border-0 p-0 m-0 flex items-center justify-center"
          role="button"
          (click)="
            navigateToCheckin(content.checkInOpenNewTab, content.checkInPath)
          "
          tabindex="0"
        >
          {{ content.labels.checkInLabel }}
          <span
            *ngIf="content.checkInOpenNewTab; else checkinSameWindow"
            class="sr-only"
          >
            Open in new window
          </span>
          <ng-template #checkinSameWindow>
            <span class="sr-only">Open in same window</span>
          </ng-template>
        </button>
      </div>
    </div>
    <div
      *ngIf="
        showIropModel &&
        (content.todayTrip.flightStatus.statusColor ||
          this.getColour(content.todayTrip.iropMessage))
      "
      class="pb-[24px]"
    >
      <div
        [ngClass]="{ 'today-vs-align': !content.isDelta }"
        class="flex flex-col gap-[24px]"
      >
        <section
          *ngIf="checkMessageBanner(content.iropErrorMessage)"
          id="sticky-message-banner"
          class="message-banner h-auto overflow-hidden"
        ></section>
        <section
          *ngIf="showDefaultBanner"
          role="alert"
          id="sticky-default-banner"
          class="message-banner h-auto overflow-hidden"
        ></section>
        <div
          class="flex flex-col w-[100%] tablet:w-[656px] laptop:w-[295px] gap-[10px]"
        >
          <button
            (click)="closeIropModel()"
            *ngIf="content.todayTrip.remainOnFlight"
            class="button button-primary button-md w-full px-[32px] h-[52px] rounded-[4px] border-0 p-0 m-0 flex items-center justify-center"
            tabindex="0"
            role="button"
          >
            {{ content.labels.remainOnFlightLabel }}
          </button>

          <button
            *ngIf="
              content.todayTrip.viewTripDetails && !content.disableViewLink
            "
            class="button button-primary button-md w-full px-[32px] h-[52px] rounded-[4px] border-0 p-0 m-0 flex items-center justify-center"
            tabindex="0"
            role="button"
            (click)="tripDetailsRedirect(content)"
          >
            {{ content.labels.viewTripDetailsLabel }}
            <span class="sr-only">Open in same window</span>
            <span
              *ngIf="
                content.viewTripDetailsOpenNewTab;
                else viewTripDetailsOpenSameTab
              "
              class="sr-only"
            >
              Open in new window
            </span>
            <ng-template #viewTripDetailsOpenSameTab>
              <span class="sr-only">Open in same window</span>
            </ng-template>
            <form
              #flyoutTodayMytripsForm
              [action]="content.tripLinkFormAction"
              id="flyout-todayTrip-link"
              method="POST"
              novalidate
            >
              <input
                name="confirmationNo"
                type="hidden"
                value="{{ content.todayTrip.recordLocator }}"
              />
              <input
                name="firstName"
                type="hidden"
                value="{{ content.todayTrip.firstName }}"
              />
              <input
                name="lastName"
                type="hidden"
                value="{{ content.todayTrip.lastName }}"
              />
              <input name="flagFromMyProfile" type="hidden" value="Y" />
              <input name="interstitial" type="hidden" value="true" />
            </form>
          </button>

          <button
            class="button button-secondary button-md w-full h-[52px] rounded-[4px] border-0 p-0 m-0 flex items-center justify-center"
            id="btnSubmit"
            role="button"
            type="submit"
            *ngIf="content.todayTrip.findOtherFlights"
            (click)="
              findAlternateFlight(
                content.rebookFlag,
                content.defaultErrorMessage
              )
            "
          >
            {{ content.labels.findAlternateLabel }}
            <span
              *ngIf="
                content.findAlternateOpenNewTab;
                else findAlternateOpenSameTab
              "
              class="sr-only"
            >
              Open in new window
            </span>
            <ng-template #findAlternateOpenSameTab>
              <span class="sr-only">Open in same window</span>
            </ng-template>
          </button>
        </div>
      </div>
    </div>
  </div>

  <section
    *ngIf="
      !content.todayTrip.departureCityCode &&
      content.errorMessages.errorMessageDescription
    "
    id="sticky-error-banner"
    class="message-banner h-auto w-full"
    tabindex="1"
  ></section>
</div>
